import { Card, Container, Flex, Heading, Text } from "@chakra-ui/react";
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";
import { useSelector } from "react-redux";

const DocumentChart = ({ data1, data }) => {
  const { dashboard_data, dashboard_list } = useSelector(
    (state) => state.dashboard
  );

  const series = [
    {
      name: "Docs",
      data: dashboard_list?.documents?.map((v) => ({
        category: v.date,
        value: v.count,
      })),
    },
    {
      name: "Docs expire",
      data: dashboard_list?.docexpire?.map((v) => ({
        category: v.date,
        value: v.count,
      })),
    },
  ];

  return (
    <>
      <Heading fontSize={"xl"} mt={4}>
        Document Status
      </Heading>
      <Flex flexDirection={["column", "row"]} gap={3} mt={2}>
        <Container maxW={"full"} h={"sm"} p={0}>
          <Card h={"sm"} p={2}>
            <Text fontSize={"md"} mb={2}>
              Total Documents:{dashboard_data?.documents?.totaldocs}
            </Text>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                width={500}
                height={300}
                data={data}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="count" fill="#007BC9" />
                {/* <Bar dataKey="Empty" fill="#FFE000" /> */}
              </BarChart>
            </ResponsiveContainer>
          </Card>
        </Container>
        <Container maxW={"full"} h={"sm"} p={0}>
          <Card h={"sm"} p={2}>
            <Text fontSize={"md"} mb={2}>
              Total Documents:{dashboard_data?.documents?.totaldocs}
            </Text>

            {/* <ResponsiveContainer width="100%" height="100%">
              <LineChart width={500} height={300}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="category"
                  type="category"
                  allowDuplicatedCategory={false}
                />
                <YAxis dataKey="value" />
                <Tooltip />
                <Legend />
                {series.map((s, i) => (
                  <Line
                    dataKey="value"
                    data={s.data}
                    name={s.name}
                    key={s.name}
                    stroke={i / 2 == 0 ? "blue" : "#f00"}
                  />
                ))}
              </LineChart>
            </ResponsiveContainer> */}
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                width={500}
                height={300}
                data={dashboard_list.combinedocs}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="count"
                  stroke="blue"
                  // activeDot={{ r: 8 }}
                  name="Docs"
                />
                <Line
                  type="monotone"
                  dataKey="expcount"
                  name="Docs Expire"
                  stroke="#f00"
                />
              </LineChart>
            </ResponsiveContainer>
          </Card>
        </Container>
      </Flex>
    </>
  );
};

export default DocumentChart;
